import { bind } from '@react-rxjs/core'
import { createSignal } from '@react-rxjs/utils'
import { filter, map, switchMap, tap } from 'rxjs'
import { RegistrationData, RegistrationStudentUserMetadata } from '../types'
import { isNotNull } from './filter'
import { registrationRequest } from './signup'
import { setRegistrationSuccess } from './success'

const [studentRegistrationInput$, setStudentRegistrationInput] = createSignal<{
  input: RegistrationData & RegistrationStudentUserMetadata
}>()

// create hook for sharing latest input pending subscription to request observable
const [useLatestStudentRegistrationInput, latestStudentRegistrationInput$] = bind(
  studentRegistrationInput$,
  null
)

export { setStudentRegistrationInput, useLatestStudentRegistrationInput }

export const studentRegistrationRequest$ = latestStudentRegistrationInput$.pipe(
  filter(isNotNull),
  switchMap(({ input }) =>
    registrationRequest({ input, isGuestCheckoutEnabled: false }).pipe(
      map((response) => ({ input, response })),
      tap(setRegistrationSuccess)
    )
  )
)
